/**
 * Edit counting for the skill instruction editor's "N edits" header. Rendering the change itself is
 * left to ReactDiffViewer; this only needs the number.
 */

/** Length of the longest common subsequence of two line arrays, in O(min) memory. */
function lcsLength(left: string[], right: string[]): number {
    let previous = new Array<number>(right.length + 1).fill(0);
    let current = new Array<number>(right.length + 1).fill(0);

    for (let i = 1; i <= left.length; i++) {
        for (let j = 1; j <= right.length; j++) {
            current[j] =
                left[i - 1] === right[j - 1]
                    ? previous[j - 1] + 1
                    : Math.max(previous[j], current[j - 1]);
        }
        [previous, current] = [current, previous];
        current.fill(0);
    }

    return previous[right.length];
}

/**
 * How many line edits separate `edited` from `original`. A line swapped for another counts once
 * rather than as an add plus a remove, so the number matches what a reader would call "an edit".
 */
export function countEditedLines(original: string, edited: string): number {
    if (original === edited) return 0;

    const left = original.split("\n");
    const right = edited.split("\n");
    return Math.max(left.length, right.length) - lcsLength(left, right);
}
